  <template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="true"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
    </template>

    <template slot="search-form">
      <div @keyup.enter="handleSearch">
        <el-row>
          <el-form-item class="search-form-item" :label="$t('lang.用户编号')">
            <el-input :placeholder="$t('lang.用户编号')" v-model="searchForm.number" clearable></el-input>
          </el-form-item>
          <el-form-item class="search-form-item" :label="$t('lang.账户名')">
            <el-input :placeholder="$t('lang.账户名')" v-model="searchForm.account" clearable></el-input>
          </el-form-item>

          <el-form-item class="search-form-item" :label="$t('lang.性别')">
            <el-select :placeholder="$t('lang.性别')" clearable v-model="searchForm.gender">
              <el-option :label="$t('lang.男')" value="man"></el-option>
              <el-option :label="$t('lang.女')" value="woman"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="search-form-item" :label="$t('lang.地区')">
            <Area @change="handleChangeArea" ref="area" />
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item class="search-form-item" :label="$t('lang.注册时间')">
            <el-date-picker
                v-model="time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="~"
                :start-placeholder="$t('lang.开始日期')"
                :end-placeholder="$t('lang.结束日期')">
            </el-date-picker>
          </el-form-item>

          <el-form-item class="search-form-item" label="">
            <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{ $t('lang.搜索') }}</el-button>
            <el-button size="mini" type="primary" @click.stop="handleReset">{{ $t('lang.重置') }}</el-button>
          </el-form-item>
        </el-row>
      </div>
    </template>


    <template slot="table">


      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column :label="$t('lang.头像')">
          <template slot-scope="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.portrait | filterImg(that)"/>

          </template>
        </el-table-column>
        <el-table-column prop="number" :label="$t('lang.用户编号')"></el-table-column>
        <el-table-column prop="account" :label="$t('lang.账户名')"></el-table-column>
        <el-table-column prop="nickname" :label="$t('lang.昵称')"></el-table-column>
        <el-table-column prop="genderName" :label="$t('lang.性别')"></el-table-column>
        <el-table-column prop="age" :label="$t('lang.年龄')"></el-table-column>
        <el-table-column prop="areaName" :label="$t('lang.地区')"></el-table-column>
        <el-table-column prop="registerTimeStr" :label="$t('lang.注册时间')" width="160"></el-table-column>
        <el-table-column prop="statusName" :label="$t('lang.状态')">
          <template v-slot="{row}">
            {{$t(`lang.${row.statusName}`)}}
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click='$router.push({path: "/user-detail",query: {code: scope.row.code} });' plain
                       type="primary">{{$t('lang.查看')}}
            </el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{$t('lang.删除')}}</el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>


  </fb-list-body>
</template>

<script>
import Area from "../../components/area/Area";
export default {
  name: "UserList",
  components: {Area},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.user.list,
        delete: this.$api.user.delete,
        batchDelete: this.$api.user.batchDelete,
      },
      searchForm: {
        startTime: '',
        endTime: '',
        country: '',
        city: '',
        province: ''
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      time: '',
      that: this,
    }
  },

  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    time: {
      handler(val) {
        const vm = this;
        if (val.length) {
          vm.searchForm['startTime'] = val[0];
          vm.searchForm['endTime'] = val[1];
        }
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    handleChangeArea(area) {
      if(area.length) {
        this.searchForm['country'] = area[0] ? area[0].number : '';
        this.searchForm['province'] = area[1] ? area[1].number : '';
        this.searchForm['city'] = area[2] ? area[2].number : '';
      }
    },
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      if(Object.keys(this.searchForm).length) {
        this.searchForm = {
          startTime: '',
          endTime: '',
          country: '',
          city: '',
          province: ''
        };
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.time = "";
        this.$refs.area.handleClear();
        this.handleGetData();
      }
    },

    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.searchParams.brandOwnerCode = JSON.parse(sessionStorage.getItem("login-user-info")).brandOwnerCode
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
